import React from 'react'
import { observer } from 'mobx-react'
import { Container } from 'typescript-ioc/es5'
import { SessionExpiredScreen } from '@pushly/aqe/lib/components'
import { SessionState } from '@pushly/aqe'
import { AppService } from '@halo/services/app.service'
import { AuthService } from '@halo/services/auth.service'

export const SessionExpirationScreen: React.FC = observer(() => {
    const appService = Container.get(AppService)
    const authService = Container.get(AuthService)
    const sessionState = Container.get(SessionState)

    const visible = sessionState.isAuthenticated && (appService.sessionExpired || sessionState.sessionExpired)

    return (
        <SessionExpiredScreen
            visible={visible}
            onSignIn={() => authService.logout(true)}
        />
    )
})
